export default __webpack_public_path__ + "static/media/rgs_cube@2x.e681b333.jpg";